import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const HypervergeCreate: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
